export default "mutation GenerateUploadUrl($imagesInfo:[ImageInfo!]!){uploadUrl(imagesInfo:$imagesInfo){uploads{url filename size}}}"